import React from "react";
import {
  makeStyles,
  Grid,
  Typography,
  Button,
  Hidden,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import LandingPageAppBar from "./LandingPageAppBar";
import { Image } from "semantic-ui-react";
import TextField from "@material-ui/core/TextField";
import image1 from "../assets/images/phone-number-screen.svg";
import { useDispatch } from "react-redux";
import { getOtp } from "../actions/user";
import { useHistory } from "react-router-dom";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import CustomPhoneInput from "./reusableComponents/CustomPhoneInput";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../constants/recaptcha";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    paddingTop: "80px"
  },
  sectionContainer: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      minHeight: "80vh",
      alignItems: "center",
      textAlign: "center",
    },
    justifyContent: "center",
    padding: "10%",
    // paddingLeft: '20%'
  },
  FormSection: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      textAlign: "center",
      padding: "5%",
      paddingTop: 0,
    },
  },
  ImageSection: {
    display: "flex",
    // alignItems: "flex-start",
    // margin: '5%',
    [theme.breakpoints.down("sm")]: {},
  },
  DashImage: {
    width: "90%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      position: "relative",
    },
  },
  captionText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: "120%",
    lineHeight: "27px",
    color: theme.palette.primary.main,
    margin: "2% 0",
    [theme.breakpoints.down("sm")]: {},
  },
  button: {
    width: "50%",
    color: theme.palette.defaultWhite.main,
    borderRadius: "20px",
    fontSize: 16,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  anchor: {
    textDecoration: "none",
    // order: 3,
  },
  requestDemoMarginBottom: {
    marginBottom: "3em",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "1em",
    },
  },
  mainText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: "300%",
    color: theme.palette.primary.main,
    lineHeight: "150%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10vw",
    },
  },
  phoneInputField: {
    marginTop: "5%",
    width: "250px",
    // height: '50px'
  },
  textInput: {
    width: 250,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: "0.75rem",
    marginTop: 4,
    marginLeft: 14,
  },
}));

const validationSchema = Yup.object().shape({
  contactType: Yup.string().oneOf(["mobile", "email"]).required("Select phone or email"),
  phoneNumber: Yup.string().when("contactType", {
    is: "mobile",
    then: (schema) =>
      schema
        .required("Phone number is required")
        .test("valid-phone", "Please enter a valid phone number", (value) =>
          value ? isValidPhoneNumber(value) : false
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
  emailId: Yup.string().when("contactType", {
    is: "email",
    then: (schema) =>
      schema.required("Email is required").email("Please enter a valid email address"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const initialValues = {
  phoneNumber: "",
  emailId: "",
  contactType: "email",
  countryCode: "",
};

const Main = () => {
  const classes = useStyles();
  const [submitting, setSubmitting] = React.useState(false);
  const [captchaToken, setCaptchaToken] = React.useState(null);
  const recaptchaRef = React.useRef(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = (values) => {
    if (!captchaToken) {
      alert("Please complete the reCAPTCHA verification");
      return;
    }
    const { phoneNumber, emailId, countryCode } = values;
    var bodyFormData = new FormData();
    bodyFormData.append("mobile_number", phoneNumber);
    bodyFormData.append("email_id", emailId);
    bodyFormData.append("recaptcha_token", captchaToken);
    dispatch(getOtp(bodyFormData, history, setSubmitting));
    localStorage.setItem("phoneNumber", phoneNumber || "");
    localStorage.setItem("email", emailId || "");
    localStorage.setItem("countryCode", countryCode || "");
    sessionStorage.setItem("validSession", true);
    if (recaptchaRef.current) {
      // recaptchaRef.current.reset();
    }
    setCaptchaToken(null);
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleCaptchaExpired = () => {
    setCaptchaToken(null);
  };

  return (
    <Grid>
      <LandingPageAppBar registration={true} />
      <Grid className={classes.root}>
        <Grid className={classes.sectionContainer}>
          <Grid item xs={12} md={7} className={classes.FormSection}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              validateOnChange
              validateOnBlur
            >
              {({ values, errors, touched, setFieldValue, setFieldTouched }) => (
                <Form>
                  <Grid>
                    <Typography gutterBottom className={classes.mainText}>
                      Welcome To <br />
                      TheWatchCloud
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography className={classes.captionText}>
                      To create your account, please enter your mobile number or email address and begin the registration process. Complete the registration form to join the exclusive Trade Member Club and gain access to TheWatchCloud Trading App.
                    </Typography>
                  </Grid>

                  <FormLabel component="legend" style={{ paddingTop: 20 }}>Get started with</FormLabel>
                  <RadioGroup
                    aria-label="contact type"
                    name="contactType"
                    value={values.contactType}
                    onChange={(e) => setFieldValue("contactType", e.target.value)}
                  >
                    <FormControlLabel
                      value="mobile"
                      control={<Radio />}
                      label="Mobile Number"
                    />
                    <FormControlLabel
                      value="email"
                      control={<Radio />}
                      label="Email Id"
                    />
                  </RadioGroup>

                  <Grid className={classes.requestDemoMarginBottom}>
                    {values.contactType === "mobile" ? (
                      <>
                        <PhoneInput
                          value={values.phoneNumber}
                          onChange={(val) => setFieldValue("phoneNumber", val || "")}
                          onBlur={() => setFieldTouched("phoneNumber", true)}
                          className={classes.phoneInputField}
                          inputComponent={CustomPhoneInput}
                          defaultCountry="HK"
                          addInternationalOption={false}
                          onCountryChange={(country) => setFieldValue("countryCode", country || "")}
                          withCountryCallingCode
                          international
                        />
                        {(touched.phoneNumber || errors.phoneNumber) && errors.phoneNumber && (
                          <div className={classes.errorText}>{errors.phoneNumber}</div>
                        )}
                      </>
                    ) : (
                      <>
                        <Field
                          as={TextField}
                          id="emailId"
                          name="emailId"
                          label="Email"
                          type="email"
                          variant="outlined"
                          margin="normal"
                          size="small"
                          className={classes.textInput}
                          error={(touched.emailId || errors.emailId) && Boolean(errors.emailId)}
                          helperText={((touched.emailId || errors.emailId) && errors.emailId) || ""}
                        />
                      </>
                    )}
                  </Grid>
                  <Grid style={{ marginBottom: "1em" }}>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={handleCaptchaChange}
                      onExpired={handleCaptchaExpired}
                    />
                  </Grid>
                  <Grid>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={
                        (values.contactType === "mobile"
                          ? !values.phoneNumber
                          : !values.emailId) || !captchaToken
                      }
                    >
                      Next
                    </Button>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Grid>
          <Hidden smDown>
            <Grid item xs={12} md={6} className={classes.ImageSection}>
              <Image
                src={image1}
                className={classes.DashImage}
              />
            </Grid>
          </Hidden>
          <Backdrop className={classes.backdrop} open={submitting}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Main;
